import { AmpProduct } from './ampAdvertisements.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getDeployment } from '@/redux/modules/config';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type AmpClickedUniquePayload = {
    ampProduct: AmpProduct;
    catalogId: number | null;
    houseId: number | null;
};

type AmpClickedPayload = TrackingPayload & AmpClickedUniquePayload;

const trackAmpClicked = (payload: AmpClickedPayload) => {
    track(TrackingEvents.AuctionMarketingProgram.AmpClicked, payload);
};

export const useTrackAmpClicked = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(
        ({ ampProduct, catalogId, houseId }: AmpClickedUniquePayload) => {
            trackAmpClicked({
                ampProduct,
                catalogId: catalogId || null,
                houseId: houseId || null,
                pageName: getAmplitudePageNameFromPath(pathname),
                url: getFullUrl(deployment, pathname),
            });
        },
        [pathname, deployment]
    );
};
